import { Controller } from 'stimulus';
import gsap from 'gsap';
import dataLayer from '../tracking/dataLayer';

class WhatsApp extends Controller {
  connect() {
    this.isLoaded = false;
    this.isOpen = false;
  }

  onToggleClick() {
    this.openDropout();

    if (this.isLoaded) {
      return;
    }

    import(/* webpackChunkName: "whatsapp" */ '../whatsapp/index')
      .then(({ default: whatsapp }) => {
        this.isLoaded = true;
        whatsapp();
      });
  }

  onCloseClick() {
    this.closeDropout();
  }

  onWindowKeyup(event) {
    // Escape key
    if (event.keyCode === 27 && this.isOpen) {
      this.closeDropout();
    }
  }

  openDropout() {
    gsap.set(this.dropoutTarget, {
      opacity: 0,
      x: 20,
    });

    dataLayer.event('whatsapp', 'open');

    this.isOpen = true;

    this.dropoutTarget.removeAttribute('hidden');
    this.dropoutTarget.setAttribute('aria-expanded', 'true');
    this.toggleTarget.setAttribute('aria-expanded', 'true');

    gsap.to(this.dropoutTarget, {
      opacity: 1,
      x: 0,
    });
  }

  closeDropout() {
    gsap.to(this.dropoutTarget, {
      opacity: 0,
      onComplete: () => {
        this.dropoutTarget.setAttribute('hidden', 'hidden');
        this.dropoutTarget.setAttribute('aria-expanded', 'false');
        this.toggleTarget.setAttribute('aria-expanded', 'false');
        this.toggleTarget.focus();
        this.isOpen = false;
      },
    });
  }
}

WhatsApp.targets = [
  'dropout',
  'toggle',
];

export default WhatsApp;
